import React, { useState } from 'react';
import HeaderTabs from '../HeaderTabs';
import { ERoutes } from '../../../routes';
import SideLeaf from '../../../components/SideLeaf';
import logoGerdau from '../../../assets/images/logo_gerdau.png';

interface Props {
  setIsSideMenuOpen: (isSideMenuOpen: boolean) => void;
  selectedTab: ERoutes;
  onSelectTab(selectedTab: ERoutes): void;
}

const SideMenu: React.FC<Props> = ({
  selectedTab,
  onSelectTab,
  setIsSideMenuOpen
}) => {
  const [closeSideLeaf, setCloseSideLeaf] = useState(false);

  const onChangeTab = (path: ERoutes) => {
    onSelectTab(path);
    setCloseSideLeaf(true);
  };

  const onCloseSideMenu = () => {
    setIsSideMenuOpen(false);
  };

  return (
    <SideLeaf
      from="left"
      onClose={onCloseSideMenu}
      closeSideLeafFromParent={closeSideLeaf}
      header={
        <img style={{ width: '12rem' }} src={logoGerdau} alt="logo Gerdau" />
      }
    >
      <HeaderTabs
        verticalTabs={true}
        selectedTab={selectedTab}
        onSelectTab={onChangeTab}
      />
    </SideLeaf>
  );
};

export default SideMenu;
